import Label from 'LuxKit/Label'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

const FloatingBadge = styled.span`
  position: absolute;
  top: ${rem(-6)};
  inset-inline-start: ${rem(-6)};
  z-index: 1;
`

function CharterRewardGreatValueBadge() {
  const intl = useIntl()

  return <FloatingBadge>
    <Label kind="primary" variant="highlight-primary-dark">
      {intl.formatMessage({
        id: '8zOPfXDH3x0oJRFsXpeG',
        defaultMessage: 'Great value',
      })}
    </Label>
  </FloatingBadge>
}

export default CharterRewardGreatValueBadge
